import {
  DEFAULT_TOAST_PROPS
} from "./chunk-5Z4OEWCY.mjs";
import {
  useToastTimer
} from "./chunk-CQAU5WAS.mjs";
import {
  observer
} from "./chunk-KZDHNNVD.mjs";
import {
  renderIcon
} from "./chunk-7YCII772.mjs";
import {
  primitiveColor
} from "./chunk-APYG7AGM.mjs";
import {
  EXIT_DURATION,
  byBreakpoints,
  createContext2,
  dist_exports,
  getVar,
  isObject,
  toastAddonCss,
  toastBaseCss,
  toastMessageFontCss,
  toastMessageWrapperCss,
  toastPositionCss,
  toastSizeCss,
  toastStretchCss
} from "./chunk-2BQQXROV.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-3IID4MV4.mjs";

// ../core/dist/chunk-RNYP3SNO.mjs
var [
  /**
   * @description BreakpointContext를 생성하는 Provider입니다.
   * @example <StackBreakpointProvider mobile={0} tablet={820} desktop={1024}>
   */
  StackBreakpointProvider,
  useBreakpointContext
] = createContext2("BreakpointContextProvider", {
  mobile: 0,
  tablet: 768,
  desktop: 1024
});

// ../core/dist/chunk-SXR5PBKI.mjs
import { isValidElement } from "react";
function breakpointMapper(breakpoints, targetObject, callback) {
  return Object.entries(targetObject).map(([key, value]) => {
    const breakpoint = breakpoints[key];
    if (breakpoint == null) {
      console.info(`Breakpoint ${key} \uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.`);
      return null;
    }
    return callback(breakpoint, value);
  }).filter((item) => item).sort((a, b) => a.breakpoint - b.breakpoint);
}
function mapResponsive(breakpoints, targetObject, callback) {
  if (!isObject(targetObject)) {
    return [
      callback(0, targetObject)
    ];
  }
  return breakpointMapper(
    breakpoints,
    targetObject,
    callback
  );
}
function mapResponsiveElement(breakpoints, targetObject, callback) {
  if (isValidElement(targetObject)) {
    return [
      callback(0, targetObject)
    ];
  }
  return mapResponsive(breakpoints, targetObject, callback);
}

// ../text/dist/chunk-QSHNUPQB.mjs
import { css } from "@emotion/react";
import styled from "@emotion/styled";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps2 = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var designSystemFontMap = dist_exports;
var TextBase = styled.span`
  color: ${getVar("--text-color")};
  text-align: ${getVar("--text-align")};

  ${({ fonts: fonts2 }) => {
  return fonts2 == null ? void 0 : fonts2.map(({ breakpoint, font }) => {
    return font && css`
          @media screen and (min-width: ${breakpoint}px) {
            ${designSystemFontMap[font]}
            color: ${getVar("--text-color")};
          }
        `;
  });
}};
`;

// ../text/dist/chunk-7NVV5PZ4.mjs
import { forwardRef } from "react";
import { jsx } from "@emotion/react/jsx-runtime";
var Text = forwardRef(function TextBase2(_a, ref) {
  var _b = _a, {
    as,
    children,
    font,
    style: styleFromProps,
    align,
    color
  } = _b, restProps = __objRest(_b, [
    "as",
    "children",
    "font",
    "style",
    "align",
    "color"
  ]);
  const breakpoints = useBreakpointContext("Text");
  const fonts = mapResponsive(breakpoints, font, (breakpoint, font2) => ({
    breakpoint,
    font: font2
  }));
  const style = __spreadProps2(__spreadValues2({}, styleFromProps), {
    "--text-color": color,
    "--text-align": align
  });
  return /* @__PURE__ */ jsx(TextBase, __spreadProps2(__spreadValues2({ as, ref, style, fonts }, restProps), { children }));
});

// src/Toast.tsx
import { Fragment } from "react";
import { jsx as jsx2, jsxs } from "@emotion/react/jsx-runtime";
function Toast(props) {
  const {
    id,
    size = DEFAULT_TOAST_PROPS.size,
    type,
    message,
    position = DEFAULT_TOAST_PROPS.position,
    offset = DEFAULT_TOAST_PROPS.offset,
    duration = DEFAULT_TOAST_PROPS.duration,
    dismiss,
    immediateDismiss = DEFAULT_TOAST_PROPS.immediateDismiss,
    immediateEnter = DEFAULT_TOAST_PROPS.immediateEnter,
    stretch = DEFAULT_TOAST_PROPS.stretch,
    addon,
    onClickAddon
  } = props;
  const toastTimeHandler = useToastTimer({ toastId: id, duration });
  const breakpoints = useBreakpointContext("Toast");
  const sizes = mapResponsive(breakpoints, size, (breakpoint, size2) => ({
    breakpoint,
    size: size2
  }));
  const positions = mapResponsive(
    breakpoints,
    position,
    (breakpoint, position2) => ({
      breakpoint,
      position: position2
    })
  );
  const offsets = mapResponsive(breakpoints, offset, (breakpoint, offset2) => ({
    breakpoint,
    offset: offset2
  }));
  const stretchs = mapResponsive(
    breakpoints,
    stretch,
    (breakpoint, stretch2) => ({
      breakpoint,
      stretch: stretch2
    })
  );
  const addons = mapResponsiveElement(
    breakpoints,
    addon,
    (breakpoint, addon2) => ({
      breakpoint,
      node: addon2
    })
  );
  function handleClickAddon() {
    onClickAddon == null ? void 0 : onClickAddon();
    observer.dismiss(id);
    setTimeout(() => {
      observer.delete(id);
    }, EXIT_DURATION);
  }
  return /* @__PURE__ */ jsxs(
    "div",
    __spreadProps(__spreadValues({
      css: [
        toastBaseCss(type),
        type !== "custom" && toastSizeCss(sizes),
        type !== "custom" && toastStretchCss(stretchs),
        toastPositionCss({
          positions,
          offsets,
          dismiss,
          immediateDismiss,
          immediateEnter
        })
      ]
    }, toastTimeHandler), {
      children: [
        renderIcon({ type, sizes }),
        type !== "custom" && typeof message === "string" ? /* @__PURE__ */ jsx2("div", { css: toastMessageWrapperCss(sizes), children: /* @__PURE__ */ jsx2(
          Text,
          {
            as: "span",
            color: DEFAULT_TOAST_PROPS.messageColor,
            style: { width: "max-content" },
            css: toastMessageFontCss(sizes),
            children: message
          }
        ) }) : message,
        typeof addon === "string" ? /* @__PURE__ */ jsx2(
          Text,
          {
            tabIndex: 0,
            role: "button",
            as: "span",
            font: "captionSb",
            color: primitiveColor.neutral[20],
            css: [toastAddonCss],
            onClick: handleClickAddon,
            children: addon
          }
        ) : /* @__PURE__ */ jsx2(Fragment, { children: addon && /* @__PURE__ */ jsx2("span", { css: [toastAddonCss], onClick: handleClickAddon, children: byBreakpoints(addons) }) })
      ]
    })
  );
}

export {
  Toast
};
